import React, { ReactElement } from "react";

import { marked } from "marked";

import TypingEffect from "./TypingEffect";
import { AnswersMdToHtmlProps } from "./AnswersMdToHtml.types";

export const AnswersMdToHtml = ({
  validMarkdownText,
  typingSpeed = 15,
}: AnswersMdToHtmlProps): ReactElement => {
  const htmlContent = marked.parse(validMarkdownText);

  return (
    <div className="markdown-content">
      {typingSpeed === 0 ? (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      ) : (
        <TypingEffect htmlContent={htmlContent} speed={typingSpeed} />
      )}
    </div>
  );
};
